import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header, Footer } from './components/layout';

const HomePage = lazy(() => import('./pages/HomePage').then((m) => ({ default: m.HomePage })));
const AboutPage = lazy(() => import('./pages/AboutPage').then((m) => ({ default: m.AboutPage })));
const ServicesPage = lazy(() => import('./pages/ServicesPage').then((m) => ({ default: m.ServicesPage })));
const ApproachPage = lazy(() => import('./pages/ApproachPage').then((m) => ({ default: m.ApproachPage })));
const ContactPage = lazy(() => import('./pages/ContactPage').then((m) => ({ default: m.ContactPage })));
const BlogPage = lazy(() => import('./pages/BlogPage').then((m) => ({ default: m.BlogPage })));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage').then((m) => ({ default: m.BlogPostPage })));
const AnxietyPage = lazy(() => import('./pages/services/AnxietyPage').then((m) => ({ default: m.AnxietyPage })));
const DepressionPage = lazy(() => import('./pages/services/DepressionPage').then((m) => ({ default: m.DepressionPage })));
const TraumaPage = lazy(() => import('./pages/services/TraumaPage').then((m) => ({ default: m.TraumaPage })));
const StressPage = lazy(() => import('./pages/services/StressPage').then((m) => ({ default: m.StressPage })));
const RelationshipsPage = lazy(() => import('./pages/services/RelationshipsPage').then((m) => ({ default: m.RelationshipsPage })));
const SelfEsteemPage = lazy(() => import('./pages/services/SelfEsteemPage').then((m) => ({ default: m.SelfEsteemPage })));
const ComingSoonPage = lazy(() => import('./pages/ComingSoonPage').then((m) => ({ default: m.ComingSoonPage })));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage').then((m) => ({ default: m.PrivacyPolicyPage })));
const TermsOfServicePage = lazy(() => import('./pages/TermsOfServicePage').then((m) => ({ default: m.TermsOfServicePage })));

const isComingSoonMode = import.meta.env.VITE_COMING_SOON_MODE === 'true';

function RouteFallback() {
  return (
    <div
      className="min-h-[60vh] flex items-center justify-center"
      role="status"
      aria-live="polite"
      aria-label="Loading page"
    >
      <div className="w-10 h-10 rounded-full border-2 border-primary/30 border-t-primary animate-spin" />
    </div>
  );
}

function App() {
  if (isComingSoonMode) {
    return (
      <HelmetProvider>
        <Router>
          <Suspense fallback={<RouteFallback />}>
            <ComingSoonPage />
          </Suspense>
        </Router>
      </HelmetProvider>
    );
  }

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-background flex flex-col">
          <Header />
          <div className="flex-1">
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/anxiety" element={<AnxietyPage />} />
                <Route path="/services/depression" element={<DepressionPage />} />
                <Route path="/services/trauma" element={<TraumaPage />} />
                <Route path="/services/stress" element={<StressPage />} />
                <Route path="/services/relationships" element={<RelationshipsPage />} />
                <Route path="/services/self-esteem" element={<SelfEsteemPage />} />
                <Route path="/approach" element={<ApproachPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsOfServicePage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </div>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
